import { render, staticRenderFns } from "./OrderSummary.vue?vue&type=template&id=80e25636&scoped=true&"
import script from "./OrderSummary.vue?vue&type=script&lang=js&"
export * from "./OrderSummary.vue?vue&type=script&lang=js&"
import style0 from "./OrderSummary.vue?vue&type=style&index=0&id=80e25636&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80e25636",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiButton: require('/app/components/UI/UiButton.vue').default})
